/**
 * driverRecruitment — unlock rules for the recruitment pool.
 *
 * 16/06/2026 — Extracted from HR.jsx (bug : les conditions narratives des
 * profils élites — « Réputation > 85 + 3 ans d'activité », « Certification
 * HazRoute »… — ne matchaient AUCUNE branche du filtre et retombaient sur
 * `level <= 2` → ces chauffeurs étaient invisibles à jamais).
 *
 * Décision utilisateur :
 *   • Les frères Lumery rejoignent le vivier du chasseur de tête
 *     (Karim Sefrioui, rh-tier-2) — `unlockVia: 'headhunter'`.
 *   • Les 7 autres profils élites apparaissent avec Karim ET pas avant
 *     7 mois d'exercice — `unlockVia: 'headhunter', minDays: 210`.
 *   • Les profils verrouillés sont affichés grisés avec leur condition
 *     (RecruitList) au lieu d'être cachés.
 */

export const HEADHUNTER_ELITE_MIN_DAYS = 210; // 7 mois d'exercice

/**
 * @param {Object} d    driver template from data/drivers.js
 * @param {Object} ctx  { rhTier1Unlocked, rhTier2Unlocked, vehicles,
 *                        monthlyRevenues, totalDays }
 * @returns {boolean} whether the profile is recruitable right now
 */
export function isDriverUnlocked(d, ctx = {}) {
  const {
    rhTier1Unlocked = false, rhTier2Unlocked = false,
    vehicles = [], monthlyRevenues = 0, totalDays = 0,
  } = ctx;
  // Machine-readable gate first (elite headhunter pool).
  if (d.unlockVia === 'headhunter') {
    return rhTier2Unlocked && totalDays >= (d.minDays || 0);
  }
  if (d.unlockCondition === 'rh-tier-1') return rhTier1Unlocked;
  if (d.unlockCondition === 'rh-tier-2') return rhTier2Unlocked;
  if (d.unlockCondition === 'Départ') return true; /* i18n-keep — magic data key */
  if (d.unlockCondition.includes('Porteur')) return vehicles.some(v => v.tier >= 2);
  if (d.unlockCondition.includes('frigo')) return vehicles.some(v => v.specialties?.includes('Frigorifique'));
  if (d.unlockCondition.includes('CA > 8')) return monthlyRevenues >= 8000;
  if (d.unlockCondition.includes('Semi')) return vehicles.some(v => v.tier >= 3);
  return d.level <= 2;
}

/**
 * Human-friendly unlock label for the greyed locked cards. The magic data
 * keys ('rh-tier-1' / 'rh-tier-2') are mapped to the actual support hire;
 * every other condition is already a narrative FR string.
 */
export function getUnlockConditionLabel(d) {
  if (d.unlockCondition === 'rh-tier-1') return 'Vivier RH — recrutez Nadia Cheikh (Responsable RH)';
  if (d.unlockCondition === 'rh-tier-2') return 'Vivier premium — recrutez Karim Sefrioui (Chasseur de tête)';
  return d.unlockCondition;
}
